import { Bar, mixins } from 'vue-chartjs'
import { initGlobalOptions } from 'src/components/Charts/chartConfigs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    initGlobalOptions()
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}
